// src/components/Contact.js
import React, { useState } from "react";
import { validateEmail } from "../utils/validators";
import { SencContactMessage } from "../api/auth/auth";
const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({ name: "", email: "", message: "" });

  const handleFormSubmit = async (name, email, message) => {
    console.log("Form submitted with:");
    console.log("Name:", name);
    console.log("Email:", email);
    console.log("Message:", message);
    await SencContactMessage({ name, email, message })
      .then((response) => {
        console.log("Contact message sent successfully:", response);
        alert("Message sent successfully!");
      })
      .catch((error) => {
        console.error("Error sending contact message:", error);
        alert("Failed to send message. Please try again later.");
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let formErrors = { name: "", email: "", message: "" };
    let isValid = true;

    if (!name) {
      formErrors.name = "Name is required";
      isValid = false;
    }
    if (!email) {
      formErrors.email = "Email is required";
      isValid = false;
    }
    else if (validateEmail(email)) {
      formErrors.email = validateEmail(email);
      isValid = false;
    }
    if (!message) {
      formErrors.message = "Message is required";
      isValid = false;
    }

    setErrors(formErrors);

    if (!isValid) return;

    handleFormSubmit(name, email, message);

    // Clear form after success
    setName("");
    setEmail("");
    setMessage("");
    setErrors({ name: "", email: "", message: "" });
  };
  return (
    <section id="contact" className="py-12 bg-transparent">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fadeInUp">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Get In Touch :</h2>
        </div>
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className={`w-full px-4 py-3 border ${errors.name ? "border-red-500" : "border-gray-300"
                    } rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all`}
                />
                {errors.name && (
                  <p className="mt-1 text-sm text-red-500">{errors.name}</p>
                )}
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={`w-full px-4 py-3 border ${errors.email ? "border-red-500" : "border-gray-300"
                    } rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all`}
                />
                {errors.email && (
                  <p className="mt-1 text-sm text-red-500">{errors.email}</p>
                )}
              </div>
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                Message
              </label>
              <textarea
                id="message"
                rows={6}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className={`w-full px-4 py-3 border ${errors.message ? "border-red-500" : "border-gray-300"
                  } rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all resize-none`}
              ></textarea>
              {errors.message && (
                <p className="mt-1 text-sm text-red-500">{errors.message}</p>
              )}
            </div>
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 hover:scale-105 transition-transform"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;